import { Button, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

// Shared load-failure view: a centred message with an optional Retry, used by every screen.
export default function ErrorState({ title, description, onRetry, style }) {
  return (
    <div
      role="alert"
      style={{
        textAlign: "center",
        padding: "40px 24px",
        ...style,
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          background: "#fff1f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto",
        }}
      >
        <ExclamationCircleOutlined style={{ fontSize: 28, color: "#cf1322" }} />
      </div>
      <Title level={5} style={{ margin: "16px 0 0" }}>
        {title}
      </Title>
      <Text
        type="secondary"
        style={{ display: "block", marginTop: 6, maxWidth: 380, marginInline: "auto" }}
      >
        {description}
      </Text>
      {onRetry && (
        <Button type="primary" onClick={onRetry} style={{ marginTop: 20 }}>
          Retry
        </Button>
      )}
    </div>
  );
}
